export const TASK_ASSIGNMENT_FIELDS = {
  ASSIGNED_TASKS: 'assignedTasks',
  PRIORITY: 'priority',
  NOTE: 'note',
  INWARD_DOCUMENTS: 'inwardDocuments',
  TIMELINE_MINUTES: 'timelineMinutes',
};
export const TASK_ASSIGNMENT_ERRORS = {
  EMPLOYEE: 'employeeAssignment',
  TASKS: 'taskAssignment',
  TIMELINE: 'workTimeline',
};

export const TASK_TYPE = {
  DESIGN: 'DESIGN',
  DRAWING: 'DRAWING',
};

export const TASK_TYPE_LABEL = {
  DESIGN: 'Design',
  DRAWING: 'Drawing',
};

export const TASK_PRIORITY = {
  URGENT: 'URGENT',
  HIGH: 'HIGH',
  MEDIUM: 'MEDIUM',
  LOW: 'LOW',
};

export const TASK_PRIORITY_ORDER = [
  TASK_PRIORITY.URGENT,
  TASK_PRIORITY.HIGH,
  TASK_PRIORITY.MEDIUM,
  TASK_PRIORITY.LOW,
];
